/* bios-chatroom.js — Live chat room wired to Firebase /chat path.
   Earlier versions had MARKET/CHAT tab toggling, but the tab markup was
   removed in a refactor. The script now just initializes the single
   chatroom panel: load history, accept input, post to Firebase, poll.    */
(function initChatRoom() {
  'use strict';

  var FIREBASE_URL = 'https://innocences-be2c5-default-rtdb.firebaseio.com';
  var CHAT_PATH    = '/chat';

  /* ── Elements ── */
  var chatroomMsgs   = document.getElementById('bios-chatroom-msgs');
  var chatroomInput  = document.getElementById('bios-chatroom-input');
  var chatroomSend   = document.getElementById('bios-chatroom-send');
  var chatroomNode   = document.getElementById('bios-chatroom-node');

  if (!chatroomMsgs || !chatroomInput) return;

  /* ── Node label (reuse from market board if set) ── */
  function getNode() {
    return sessionStorage.getItem('bios_market_node') || 'ANON';
  }
  if (chatroomNode) chatroomNode.textContent = 'NODE:' + getNode();

  /* ── Escape helper ── */
  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  /* ── Slur / profanity filter ──────────────────────────────────────────────
     Reject messages containing any of these (matched case-insensitively as
     whole words). Designed to be conservative — extend the list as needed. */
  var BLOCKED = [
    'nigger', 'nigga', 'niglet',
    'faggot', 'fag', 'tranny', 'shemale',
    'retard', 'retarded',
    'kike', 'chink', 'gook', 'spic', 'wetback',
    'cunt'
  ];
  var _blockRe = new RegExp('\\b(?:' + BLOCKED.join('|') + ')\\b', 'i');
  function isBlocked(text) { return _blockRe.test(text); }
  function showRejection() {
    var sys = document.createElement('div');
    sys.className   = 'bios-chat-line bios-chat-sys';
    sys.textContent = 'MESSAGE REJECTED — CONTAINS BLOCKED LANGUAGE.';
    chatroomMsgs.appendChild(sys);
    chatroomMsgs.scrollTop = chatroomMsgs.scrollHeight;
    /* fade the warning after a few seconds */
    setTimeout(function() {
      sys.style.transition = 'opacity 0.6s ease';
      sys.style.opacity    = '0';
      setTimeout(function() { if (sys.parentNode) sys.parentNode.removeChild(sys); }, 700);
    }, 4000);
  }

  /* ── Render one chat message ── */
  function renderChatMsg(key, row, isNew) {
    if (!row || !row.msg) return null;
    var el = document.createElement('div');
    el.className = 'bios-chat-line bios-chatroom-line' + (isNew ? ' bios-chat-new' : '');
    el.dataset.chatKey = key;

    var ts = new Date(row.ts || Date.now()).toLocaleTimeString('en-US', {
      hour: '2-digit', minute: '2-digit', hour12: false
    });

    el.innerHTML = '<span class="bios-chat-origin">' + esc(row.node || 'ANON') + '</span>'
      + '<span class="bios-chat-time"> · ' + ts + '</span><br>'
      + '<span class="bios-chat-text">' + esc(row.msg) + '</span>';

    if (isNew) setTimeout(function() { el.classList.remove('bios-chat-new'); }, 3500);
    return el;
  }

  /* ── Firebase chat fetch ── */
  var _chatLoaded = false;
  var _chatSeen   = {};

  function showSysMessage(text, persistent) {
    /* Replace existing sys message with the new one (don't stack identical errors). */
    var prev = chatroomMsgs.querySelector('.bios-chat-sys');
    if (prev) prev.parentNode.removeChild(prev);
    var sys = document.createElement('div');
    sys.className   = 'bios-chat-line bios-chat-sys';
    sys.textContent = text;
    chatroomMsgs.appendChild(sys);
  }

  function fetchChat() {
    fetch(FIREBASE_URL + CHAT_PATH + '.json?orderBy=%22%24key%22&limitToLast=60')
      .then(function(r) {
        return r.json().then(function(data) { return { ok: r.ok, status: r.status, data: data }; });
      })
      .then(function(res) {
        var isFirst = !_chatLoaded;
        _chatLoaded = true;

        if (!res.ok) {
          /* Firebase returned an error — most commonly 401 "Permission denied"
             when the database rules don't allow public read. Show a clear sys
             message instead of leaving the room blank. */
          var msg = (res.data && res.data.error) ? String(res.data.error).toUpperCase() : ('HTTP ' + res.status);
          showSysMessage('// CHAT UNREACHABLE — ' + msg);
          return;
        }

        if (!res.data) {
          if (isFirst) showSysMessage('NO MESSAGES YET — SAY SOMETHING.');
          return;
        }

        var appended = false;
        Object.keys(res.data).sort().forEach(function(k) {
          if (_chatSeen[k]) return;
          _chatSeen[k] = true;
          var el = renderChatMsg(k, res.data[k], !isFirst);
          if (!el) return;
          chatroomMsgs.appendChild(el);
          appended = true;
        });

        if (appended) chatroomMsgs.scrollTop = chatroomMsgs.scrollHeight;
      })
      .catch(function(err) {
        showSysMessage('// CHAT UNREACHABLE — NETWORK ERROR');
      });
  }

  /* ── Send a chat message ── */
  function sendChatMsg() {
    if (!chatroomInput.value.trim()) return;
    var text = chatroomInput.value.trim().slice(0, 140);
    if (isBlocked(text)) {
      showRejection();
      /* leave the input intact so the user can edit; just disable send until they retype */
      if (chatroomSend) chatroomSend.disabled = true;
      return;
    }
    chatroomInput.value = '';
    if (chatroomSend) chatroomSend.disabled = true;

    fetch(FIREBASE_URL + CHAT_PATH + '.json', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ msg: text, node: getNode(), ts: Date.now() })
    })
      .then(function(r) {
        if (!r.ok) {
          return r.json().then(function(d) {
            var msg = (d && d.error) ? String(d.error).toUpperCase() : ('HTTP ' + r.status);
            throw new Error(msg);
          });
        }
        return r.json();
      })
      .then(function() { setTimeout(fetchChat, 600); })
      .catch(function(err) {
        showSysMessage('// MESSAGE NOT SENT — ' + (err && err.message ? err.message : 'NETWORK ERROR'));
        /* Restore the unsent text so the user can edit/retry */
        chatroomInput.value = text;
        if (chatroomSend) chatroomSend.disabled = false;
      });
  }

  /* ── Wire inputs ── */
  chatroomInput.addEventListener('input', function() {
    if (chatroomSend) chatroomSend.disabled = !chatroomInput.value.trim();
  });
  chatroomInput.addEventListener('keydown', function(e) {
    e.stopPropagation(); /* prevent drum scroll */
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendChatMsg(); }
  }, true);
  if (chatroomSend) chatroomSend.addEventListener('click', sendChatMsg);

  /* ── Initial fetch + poll every 20s for new messages ── */
  fetchChat();
  setInterval(fetchChat, 20000);

})();
